import HelpChat from "./HelpChat.vue";
import HelpChatWindow from "./HelpChatWindow.vue";

function lock(user) {
    return [user?.Basic?.showBetaFeatures !== true, "Show beta features is turned off."];
}

export default [{
    path: "/Home/HelpChat",
    component: HelpChat,
    name: "Help Chat",
    meta: {
        app: "Agent",
        name: "Help Chat",
        appSwitcher: true,
        appSwitcherPosition: 99,
        icon: "robot",
        sideNav: false,
        sideNavPosition: 2,
        sideNavSection: "Agent",
        watch: false,
        lock,
    }
}, {
    path: "/Home/HelpChat/window",
    component: HelpChatWindow,
    name: "Help Chat Window",
    meta: {
        app: "Agent",
        name: "Help Chat",
        sideNav: false,
        appSwitcher: false,
        watch: false,
        helpChatWindow: true,
        lock,
    }
}];
